const slackConfig = {
  clientId: process.env.REACT_APP_SLACK_CLIENT_ID,
};

export default slackConfig;
